export default __webpack_public_path__ + "static/media/arrow-up.8c847189.svg";